import { take, filter, map, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

/**
 * @class
 * @extend {import('./pusher.module').IPusherService}
 */
export class PusherService {

  /** @type {Subject<any>} */
  events$ = new Subject();

  /** @type {import('pusher-js').default} */
  client;

  /** @type {string} */
  apiKey;
  /** @type {string} */
  cluster;

  constructor(apiKey, cluster) {
    this.apiKey = apiKey;
    this.cluster = cluster;
  }

  /**
   * @param {string} userId
   */
  connect(userId) {
    // @ts-ignore
    // Pusher.logToConsole = true;

    // @ts-ignore
    this.client = new Pusher(this.apiKey, {
      cluster: this.cluster,
    });

    var channel = this.client.subscribe('private-' + userId);
    channel.bind_global((eventName, data) => {
      // console.log("PusherService -> ", eventName, data);
      this.events$.next({ eventName, data });
    });
  }

}

export default PusherService;